"use strict";

(function(){

const self = Fotobook.quota = {
    quotaInfo: undefined,
    getInfo(forceUpdate = false) {
        if (this._quotaInfo && !forceUpdate) {
            return Promise.resolve(this._quotaInfo);
        }
        return Fotobook.$http.get('/user/quota/info', {
            queue: false,
        }).then((response) => {
            this._quotaInfo = response.data;
            return response.data;
        });
    },
    dialog(response){
        $('.ui-dialog:visible:not(.upload-foto-dialog)').remove();
        Fotobook.dialog.alert(response, {
            "title": t('photobook-js-quotaLimitReached'),
            "dialogClass": "upper-dialog",
            "width": 400,
        });
    },
};

$(document)
.on(Fotobook.events.AJAX_DONE, function(event, result, response){
    const data = response ? response.data : null;
    if (data && data.quotaInfo && data.quotaInfo.exceeded && data.quotaInfo.message) {
        self.dialog(data.quotaInfo.message);
    }
});

})();
